import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './delete-account.style';

export const DeleteAccountLoading: React.FC = () => (
  <Styled.Loading>
    <CircularProgress />
  </Styled.Loading>
);
